<template>
    <div class="order">
        <HeaderTop></HeaderTop>
        <HeaderTitle :pageName="pagename" :topType="toptype"></HeaderTitle>
        <div class="word">
            <section>
                <div class="page-title">填写并核对订单信息</div>
                <div class="msgbox">
                    <div class="box-top-title">收货人信息</div>
                    <div class="add-address">新增收货地址</div>
                    <div class="address">
                        <span class="no-add" v-if="address.length == 0">暂无地址，去新建~</span>
                        <div class="address-list" v-else>
                            <div v-for="(item,index) in address" :key="index" class="address-item">
                                <div class="address-l">
                                    <div class="name-box">{{item.name}}</div>
                                    <div class="add-detail">{{item.iname}} {{item.address}}</div>
                                    <span class="mor" v-if="item.id == 0">默认地址</span>
                                </div>
                                <div class="address-btn">
                                    编辑
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="box-top-title order-msg-title">确认订单信息</div>
                    <div class="goods">
                        <div class="goods-tltie">
                            <div class="fir-title">商品信息</div>
                            <div class="se-title">单价</div>
                            <div class="th-title">数量</div>
                            <div class="for-title">金额</div>
                        </div>
                        <div class="goods-list">
                            <div class="goods-list-l">
                                <div  class="goodsimg">
                                <img src="" alt="">
                            </div>
                            <div class="goods-msg">
                                RS-232 RS-422  RS-485 电能、功率计量，照明系统，RS-232 RS-422  RS-485 电能、功率计量，照明系统，RS-232 RS-422  RS-485 电能、功率计量，照明系统，RS-232 RS-422  RS-485 电能、功率计量，照明系统，RS-232 RS-422  RS-485 电能、功率计量，照明系统，
                            </div>
                            <div class="goods-msg-more">
                                规格：HTTP999型号：RS-232 RS-422
                            </div>
                            <div class="single-price">$199.00</div>
                            <div class="num">x1</div>
                            </div>
                            <div class="price">$123</div>
                        </div>
                        <div class="goods-list">
                            <div class="goods-list-l">
                                <div  class="goodsimg">
                                <img src="" alt="">
                            </div>
                            <div class="goods-msg">
                                RS-232 RS-422  RS-485 电能、功率计量，照明系统，RS-232 RS-422  RS-485 电能、功率计量，照明系统，RS-232 RS-422  RS-485 电能、功率计量，照明系统，RS-232 RS-422  RS-485 电能、功率计量，照明系统，RS-232 RS-422  RS-485 电能、功率计量，照明系统，
                            </div>
                            <div class="goods-msg-more">
                                规格：HTTP999型号：RS-232 RS-422
                            </div>
                            <div class="single-price">$199.00</div>
                            <div class="num">x1</div>
                            </div>
                            <div class="price">$123</div>
                        </div>


                        <div class="order-detail-msg">
                            <div class="order-detail-msg-l" >
                                <span class="msg-btn"></span>
                                <span>使用<span class="core">100</span>积分抵扣5.00元</span>
                                <span class="delete-price">-5.00</span>
                                <span class="methods">运送方式：普通配送 快递 免邮</span>
                            </div>
                            <div class="order-detail-price">0.00</div>
                        </div>

                        <div class="bottom-msg">
                            <div class="bottom-l">商品合计(含运费)</div>
                            <div class="allprice">$123132.00</div>
                        </div>

                        <div class="order-font">
                            <div class="order-font-box">
                                <div class="title">实际付款：<span class="order-p">$1299.00</span></div>
                                <div class="title le">寄送至：<span class="order-a">四川 成都 武侯 普天小区 7栋二单元101 </span></div>
                                <div class="title le">收货人：<span class="order-a">赵四儿 19934454418</span></div>
                            </div>
                            <div class="order-font-btn">立即支付</div>
                        </div>

                    </div>

                </div>

                

            <div class="footer">
               <PageFooter></PageFooter>
            </div>
            </section>
            
        </div>
        <!-- 添加地址 -->
        <AddAddress></AddAddress>
    </div>
</template>
<script>
import HeaderTop from '../assembly/HeaderTop'
import HeaderTitle from '../assembly/HeaderTitle'
  import PageFooter from "../assembly/PageFooter";
  import AddAddress from "../assembly/AddAddress";
export default {
    components:{
        HeaderTop,HeaderTitle,PageFooter,AddAddress
    },
    data(){
        return {
            pagename:'购物车',
            toptype:'line',
            address:[
                {id:0,name:'赵四',iname:'赵乐',address:'赵乐 四川 成都市 武侯区 城区 普天小区7栋二单元101',phone:'130****5129'},
                {id:1,name:'赵四',iname:'赵乐',address:'赵乐 四川 成都市 武侯区 城区 普天小区7栋二单元101',phone:'130****5129'},
            ]
        }
    }
}
</script>
<style scoped>
section{
    min-width: 1200px;
}
.order{
    width: 100%;
    min-height: 100vh;
    background: #fff;
}
.page-title{
    font-size: 16px;
    color: #555;
    margin-top: 79px;
    text-align: left;
    margin-bottom: 10px;
}
.msgbox{
    border: 1px solid #E2E2E2;
    box-sizing: border-box;
    padding: 20px 60px;
    font-size: 14px;
    margin-bottom: 170px;
}
.box-top-title{
    color: #333333;
    font-size: 14px;
    text-align: left;
    font-weight: bold;
}
.add-address{
    font-size: 13px;
    color: #0876CD;
    text-align: right;
}
.address{
    font-size: 13px;
    color: #666;
    padding-bottom: 25px;
    border-bottom: 1px solid #E2E2E2;
}
.no-add{
   border: 1px solid #E2E2E2;
   padding: 5px 10px;
   margin: 0 auto;
}
.address-item{
    display: flex;
    justify-content: space-between;
    margin-bottom: 18px;
    align-items: center;
}
.address-item:last-child{
    margin-bottom: 0;
}
.name-box{
    width: 144px;
    height: 30px;
    border: 1px solid #E2E2E2;
    line-height: 30px;
    text-align: center;
}
.add-detail{
    line-height: 30px;
    margin-left: 22px;
}
.address-list{
    margin-top: 8px;
}
.address-l{
    display: flex;
    flex: 1;
    align-items: center;
}
.address-btn{
    width: 43px;
    height: 21px;
    border: 1px solid #BBBBBB;
    line-height: 21px;
    text-align: center;
}
.mor{
    margin-right: 7px;
    display: inline-block;
    width: 60px;
    height: 21px;
    background-image: linear-gradient(#3699E5,#0876CE);
    color: #fff;
    font-size: 12px;
    line-height: 21px;
}
.order-msg-title{
    margin-top: 25px;
}
.goods-tltie{
    display: flex;
    align-items: center;
    padding-top: 33px;
    padding-bottom: 15px;
    font-size: 13px;
    color: #4A4A4A;
    border-bottom: 4px solid #0D79CF;
}
.fir-title{
    width: 192px;
    text-align: right;
}
.se-title{
    width: 500px;
    text-align: right;
}
.goods-list{
    display: flex;
    padding:20px;
    border-bottom: 1px dashed #0D79CF;
    justify-content: space-between;
}
.goods-list-l{
    display: flex;
}
.goodsimg{
    width: 80px;
    height: 80px;
    border: 1px solid #F1F1F1;
}
.goodsimg img{
    width: 100%;
    height: 100%;
    display: block;
}
.goods-msg{
    margin-left: 40px;
    font-size: 14px;
    color: #000;
    text-align: left;
    width: 210px;
}
.goods-msg-more{
    color: #666666;
    margin-left: 65px;
    width: 150px;
    text-align: left;
}
.single-price{
    color: #1A1A1A;
    font-weight: bold;
    margin-left: 93px;
}
.num{
    margin-left: 99px;
    font-weight: bold;
}
.th-title{
    width: 140px;
    text-align: right;
    
}
.for-title{
    width: 110px;
    text-align: right;
}
.price{
    color: #EA2323;
    font-size: 14px;
    font-weight: bold;
    width: 142px;
    text-align: left;
}
.order-detail-msg{
    height: 56px;
    display: flex;
    background: #F2F7FF;
    padding-left: 27px;
    align-items: center;
    /* justify-content: space-between; */
}
.order-detail-msg-l{
    display: flex;
    align-items: center;
    width: 890px;
}
.order-detail-price{
    width: 142px;
    text-align: left;
    color: #EA2323;
    font-weight: bold;
}
.msg-btn{
    width: 12px;
    height: 12px;
    margin-right: 7px;
    border: 1px solid #B2B2B2;
    display: inline-block;
    background:linear-gradient(0deg,rgba(222,222,222,1) 0%,rgba(255,255,255,1) 100%);
}
.core{
    color: #EB3A3B;
}
.delete-price{
    color: #EB3A3B;
    font-weight: bold;
    margin-left: 194px;
    font-size: 14px;
}
.methods{
    margin-left: 84px;
}
.bottom-msg{
    background: #F2F7FF;
    margin-top: 3px;
    height: 50px;
    display: flex;
    align-items: center;
    border-bottom: 1px dashed #0D79CF;
}
.bottom-l{
    width: 917px;
    padding-right: 100px;
    text-align: right;
    box-sizing: border-box;
}
.allprice{
    color: #EA2323;
    font-weight: bold;
}
.order-font{
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    
}
.order-font-box{
    border: 1px solid #0775CC;
    width: 333px;
    margin-top: 25px;
    padding:24px 18px;
    box-sizing: border-box;
}
.order-font .title{
    text-align: right;
}
.order-font-btn{
    width: 181px;
    height: 50px;
    background:linear-gradient(0deg,rgba(5,115,203,1) 0%,rgba(63,159,234,1) 100%);
    color: #fff;
    font-size: 18px;
    line-height: 50px;
    text-align: center;
}
.order-p{
    font-size: 24px;
    color: #EA2323;
}
.order-a{
    font-size: 13px;
    color: #666;
}
.le{
    margin-top: 12px;
}
</style>


// WEBPACK FOOTER //
// src/components/order/Order.vue